module.exports = new __parcel__URL__("coincraft_logo_130.1b205a5d.png").toString();